import React, { FunctionComponent } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { useUserAccess } from '../components/hooks';
import { AuthState } from '../reducers/types';
import { AppState } from '../store';
import { UserTypeValues } from '../types';

interface IProps {
  auth: AuthState;
}

const LandingPage: FunctionComponent<IProps> = ({ auth }) => {
  useUserAccess(auth);

  const { isAuthenticated, user } = auth;
  const allowedUserTypes = [UserTypeValues.Admin as string, UserTypeValues.Operador as string];

  if (isAuthenticated) {
    if (allowedUserTypes.includes(user!.userTypeName)) {
      return <Redirect to='/politicas/reportes-cd-cl' />;
    }
  }

  return null;
};

export default connect(({ auth }: AppState) => ({ auth }))(LandingPage);
